import React, { lazy, useContext, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import * as api from 'da-pcc-frontend-accountmanagement-api';

import { MyAccountTiles } from '../Navigation';
import AccountContext from '../Context/AccountContext';
import Loader from '../Common/Loader';

const Details = lazy(() => import('./Detail'));

const Users = lazy(() => import('./Users'));

const Groups = lazy(() => import('./Groups'));

const AccountDetails = () => {

  // Check permissions for various sections
  const [account] = useContext(AccountContext);

  const canViewUsers =
    account.accountPermissions.has(api.AccountPermission.CanViewUsers) ||
    account.accountPermissions.has(api.AccountPermission.CanManageUsers);

  return <>
    <MyAccountTiles />

    <Suspense fallback={<Loader />}>
      <Switch>
        {canViewUsers && <Route path="/:id/My/Account/Users/:section?" children={<Users />} />}
        <Route path="/:id/My/Account/Groups" children={<Groups />} />
        <Route path="/:id/My/Account/Detail/:section?" children={<Details />} />
      </Switch>
    </Suspense>
  </>
};

export default AccountDetails;